import { Eye, EyeOff } from "lucide-react"
import type { ComponentProps } from "react"
import { useState } from "react"

import { Input } from "./Input"
import { cn } from "../lib/cn"

export function PasswordInput({
  className,
  ...props
}: Omit<ComponentProps<"input">, "type">) {
  const [mostrarSenha, definirMostrarSenha] = useState(false)

  return (
    <div className="relative">
      <Input
        type={mostrarSenha ? "text" : "password"}
        maiusculas={false}
        className={cn("pr-10", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => definirMostrarSenha((atual) => !atual)}
        className="absolute inset-y-0 right-0 flex cursor-pointer items-center rounded-r-md px-3 text-muted-foreground transition-colors hover:text-foreground"
        aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
        tabIndex={-1}
      >
        {mostrarSenha ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
      </button>
    </div>
  )
}
